module.exports = __webpack_public_path__ + "static/red-world-769144ff8820feefeac108d78c9955ca.png";